import { deleteReport } from "../services/reportsApi";

/** Best-effort cleanup when async report generation fails — do not leave failed rows in the user’s list. */
export async function deleteFailedGeneratedReport(reportId: string): Promise<void> {
  const id = reportId.trim();
  if (!id || id.startsWith("pending-")) return;
  try {
    await deleteReport(id);
  } catch {
    // Ignore — UI already dismissed; a later refresh can retry cleanup.
  }
}
